module.exports = __webpack_public_path__ + "img/banner.2fe4dd95.png";